var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-pane-wrapper h-auto", attrs: { id: "note-tab" } },
    [
      _c(
        "form",
        {
          staticClass: "h-100 d-flex flex-column align-items-end",
          attrs: { id: "note-form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "form-group-material form-group-wide no-validation-icons",
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note,
                    expression: "note",
                  },
                ],
                ref: "referrerNoteField",
                staticClass: "form-control required",
                attrs: { type: "text", name: "note" },
                domProps: { value: _vm.note },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.note = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown" },
            [
              _c(
                "simple-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.left",
                      value: {
                        title: _vm.$t(
                          "client-profile.messages.doubleClickToAdd"
                        ),
                      },
                      expression:
                        "{\n          title: $t('client-profile.messages.doubleClickToAdd')\n        }",
                      modifiers: { left: true },
                    },
                  ],
                  attrs: {
                    type: "primary",
                    "class-name": "btn-sm p-0",
                    disabled: !_vm.canSave,
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingSucceeded,
                  },
                  on: { dblclick: _vm.handleSubmit },
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      ref: "addNoteActionsDropdown",
                      attrs: {
                        variant: "primary btn-sm",
                        "toggle-class": "btn-sm shadow-none b-0",
                        "menu-class": "overflow-visible",
                        right: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "d-lg-inline d-none" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("client-profile.actions.addNote")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "i",
                                { staticClass: "material-icons d-lg-none" },
                                [_vm._v("more_vert")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleAddNote(false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("client-profile.actions.addNote")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleAddNote(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("client-profile.actions.addNote")) +
                              " +\n            " +
                              _vm._s(_vm.$tc("global.words.activity", 1)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }